<template>
	<div class="statistica__per-month">
		<div class="statistica__item">
            <div class="statistica__per-month-title">
                <div class="statistica__per-month-title_text">{{getNowDay}}
                </div>
                <div class="statistica__per-month-title_data">
                    <span>
                        <watch :data="profitAbs"
							   :units="'$'"
					   >
                        </watch>
                    </span>
                    <span>
                        <watch :data="profitPercent"
							   :units="'%'"
						>
                        </watch>
                    </span>
                </div>
            </div>
            <div class="statistica__per-month-row">
                <chart :points = "points" :fixedWidth = "320"
                :fixedHeight = "110" :smooth="false" :data="this.profitAbs"></chart>
            </div>
        </div>
	</div>
</template>

<script>
import { mapGetters } from "vuex";
import Vue from 'vue';
import Chart from '../../../ui-components/ui-mini-linechart';
import Watcher from '../../../ui-components/ui-data-watcher';

export default {
    components: {
        'chart':Chart,
        'watch':Watcher
    },
	data() {
		return {
            profitAbs:0,
            profitPercent:0,
            points:0,
            month:['Января','Февраля','Марта','Апреля','Мая','Июня','Июля','Августа','Сентября','Октября','Ноября','Декабря']
		};
	},
	computed: {
		...mapGetters({
            getStatistics: 'accountstat/getStatistics'
        }),
        getNowDay() {
            let nowDate = new Date();
            return `${nowDate.getDate()} ${this.month[nowDate.getMonth()]}`
        }
	},
	methods: {
		updateData() {
            let stat = this.getStatistics('');
            if(!stat)
                return;
            let data = getPoints(stat);
            this.points = data.points;
            this.profitAbs = data.profit;
            this.profitPercent = data.profitPercent;
        }
	},
	created() {
        subscribeOnUpdate(this.$store, '', isFirstObtained => {
            this.updateData();

        });
        this.updateData();
    } // created }
};
function getPoints(stats) {
    let chartPoints = {
        points:[],
    }; //Data Object for Chart
    let nowDate = new Date();
    for(let i = 0; i < stats.HourlyRecords.length; i++) {
        if (nowDate.getDate() === new Date(stats.HourlyRecords[i].Date).getDate())
        chartPoints.points.push(stats.HourlyRecords[i]);
    }// Data for Points
    let pointsData = [];
        for(let i = 0; i < chartPoints.points.length; i++)
            pointsData.push(chartPoints.points[i].EquityClose)
    let data = {
        points: pointsData,
        profit: chartPoints.points[chartPoints.points.length - 1].EquityClose - chartPoints.points[0].EquityOpen,
        profitPercent: 100/(chartPoints.points[0].EquityOpen/(chartPoints.points[chartPoints.points.length - 1].EquityClose - chartPoints.points[0].EquityOpen))
    }
    return data;
}
function subscribeOnUpdate(store, symbol, handler) {
    store.dispatch("accountstat/subscribeOnUpdate", {
        symbol: "",
        callback: {
            id: "day-widget-desktop",
            handler: handler
        }
    });
}



</script>

<style lang="less" scoped>
.statistica {
    &-popup {
        position: fixed;
        top:30%;
        left:8px;
        right: 8px;
        max-width: 100%;
        background: #3d536b;
        border-radius: 8px;
        padding: 8px;
        z-index: 10;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    &-overlay {
        position: fixed;
        display: block;
        left: 0;
        margin-right: 8px;
        top:0;
        width: 100%;
        min-height: 100vh;
        background:rgba(0,0,0,0.7);
        z-index: 1;
    }
    &-changeDate {
        display: flex;
        flex-direction: column;
        align-items: center;
        &-item {
            display: flex;
            flex-direction: column;
            &-options {
                display: flex;
                flex-direction: column;
                margin-right: 16px;
                &:last-child {
                    margin-right: 0px;
                }

            }
        }
        select {
            font-family: Montserrat;
            font-weight: 600;
            font-style: normal;
            font-stretch: normal;
            font-size: 120%;
            background: #fff;
            padding: 4px;
            border-radius: 4px;
            width: 280px;
        }
        span {
            font-family: Montserrat;
            font-size: 20px;
            font-weight: 600;
            font-style: normal;
            font-stretch: normal;
            line-height: normal;
            letter-spacing: 0.4px;
            color: #fff;
            margin-right: 16px;
        }
    }
}
input[type="button"]
    {
        height: 40px;
        border-radius: 4px;
        width: 100px;
        background-color: #0fd7b7;
        border: none;
        margin-top: 16px;
        color:#374b62;
        cursor: pointer;
        font-family: Arimo;
        font-size: 13px;
        font-weight: bold;

        &:disabled
        {
            background-color: #718da8;

            &:hover
            {
              background-color: #718da8;
            }
        }

        &:hover
        {
            background-color: @colors[green];
        }
}
.statistica__item {
    margin-bottom: 8px;
    display: block;
    background: #3d536b;
    border-radius: 4px;
    overflow: hidden;
}
.statistica__per-month {
    width: 100%;
    &-title {
        font-family: Montserrat;
        font-weight: normal;
        font-size: 17px;
        font-style: normal;
        font-stretch: normal;
        //text-transform: uppercase;
        color: #ffffff;
        padding-left: 16px;
        background-color: #3d536b;
        border-bottom: 1px solid #374b62;
        margin-bottom: 0px;
        padding: 8px 8px;
        height: 45px;
        box-sizing: border-box;
        display: flex;
        justify-content: space-between;
        &_text {
            display: flex;
            align-items: center;
        }
        &_data {
            display: flex;
            align-items: center;
        }
        i {
            margin-left: 8px;
            margin-top: 4px;
        }
        span {
            font-family: Arimo;
            //font-weight: 600;
            margin-right: 8px;
            &:first-child {
                margin-left: 8px;
            }
            &:last-child {
                margin-right: 0px;
            }
        }
    }
    &-row {
       display: flex;
       justify-content: center;
        padding-top: 8px;
    }

    &-item {
        border-top: solid 1px #374b62;
        padding: 0 8px 0 12px;
        height: 29px;
        &-title{
            padding: 8px 0;
            border-bottom: 1px solid #374b62;
            display: flex;
            justify-content: space-between;

            &-day {
                font-family: Arimo;
                font-size: 12px;
                font-style: normal;
                font-stretch: normal;
                line-height: 2;
                letter-spacing: 0.4px;
                text-transform: uppercase;
                padding-left: 16px;
                color: #ffffff;
            }

            &-date {
                font-family: Arimo;
                font-size: 12px;
                font-style: normal;
                font-stretch: normal;
                line-height: 2;
                letter-spacing: 0.4px;
                text-transform: uppercase;
                padding-right: 12px;
                color: #aabed2
            }
        }

        &-data {
            padding: 12px 12px 8px 12px;

            &-sum {
                font-family: Arimo;
                font-size: 13px;
                font-weight: bold;
                font-style: normal;
                font-stretch: normal;
                line-height: 1.25;
                letter-spacing: 0.4px;
                text-align: left;
            }

            &-pips {
                font-family: Arimo;
                font-size: 13px;
                font-weight: bold;
                font-style: normal;
                font-stretch: normal;
                line-height: 1.54;
                letter-spacing: 0.4px;
            }

            &-probability {
                font-family: Arimo;
                font-size: 12px;
                font-weight: bold;
                font-style: normal;
                font-stretch: normal;
                line-height: 2;
                letter-spacing: 0.4px;
                text-transform: uppercase;
                color: @colors[green];
                margin-top: 8px;
            }

            &-maxdd {
                font-family: Arimo;
                font-size: 12px;
                font-weight: bold;
                font-style: normal;
                font-stretch: normal;
                line-height: 2;
                letter-spacing: 0.4px;
                color: @colors[red];
                }
        }

        &-chart {
            width: 100%;
            display: block;
            //flex-grow: 1;
            min-height: 200px;
        }
    }
}
</style>
